export default __webpack_public_path__ + "static/media/noexpl_03_EN.fa04e2d7.png";